import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FaArrowRight, FaBullhorn } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

import {
  getPresaleTimeLeft,
  hasPresaleCountdownEnded,
} from "../../utils/presaleCountdown";
import "./Modal.css";

const COUNTDOWN_LABELS = [
  ["days", "Days"],
  ["hours", "Hours"],
  ["minutes", "Mins"],
  ["seconds", "Secs"],
];

const PresaleAnnouncementModal = ({ show, onClose, onParticipate }) => {
  const [timeLeft, setTimeLeft] = useState(getPresaleTimeLeft);
  const countdownEnded = hasPresaleCountdownEnded(timeLeft);

  useEffect(() => {
    if (!show) return undefined;

    const immediateTimer = window.setTimeout(
      () => setTimeLeft(getPresaleTimeLeft()),
      0,
    );
    const timer = window.setInterval(
      () => setTimeLeft(getPresaleTimeLeft()),
      1_000,
    );

    return () => {
      window.clearTimeout(immediateTimer);
      window.clearInterval(timer);
    };
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="presale-announcement-modal"
      aria-labelledby="presale-announcement-title"
      aria-describedby="presale-announcement-copy"
    >
      <Modal.Body>
        <button
          type="button"
          className="presale-announcement-modal__close"
          onClick={onClose}
          aria-label="Close presale announcement"
        >
          <IoClose size={22} aria-hidden="true" />
        </button>

        <div className="presale-announcement-modal__signal" aria-hidden="true">
          <span className="presale-announcement-modal__signal-ring" />
          <FaBullhorn />
        </div>

        <span className="presale-announcement-modal__eyebrow">
          <i aria-hidden="true" /> Official announcement
        </span>
        <span className="presale-announcement-modal__round-badge">Round 2</span>

        <h2 id="presale-announcement-title">
          {countdownEnded ? (
            "Presale Update"
          ) : (
            <>
              <strong className="presale-announcement-modal__brand-mark">
                1EYE
              </strong>{" "}
              Presale Is Live
            </>
          )}
        </h2>
        <p id="presale-announcement-copy">
          {countdownEnded
            ? "The scheduled presale countdown has ended. Visit the presale card for the latest status."
            : "The participation window is open. Secure your allocation before the countdown reaches zero."}
        </p>

        <div
          className="presale-announcement-modal__countdown"
          aria-label="Time remaining in presale"
        >
          {COUNTDOWN_LABELS.map(([key, label]) => (
            <div key={key}>
              <strong>{timeLeft[key]}</strong>
              <small>{label}</small>
            </div>
          ))}
        </div>

        <button
          type="button"
          className="presale-announcement-modal__cta"
          onClick={onParticipate}
        >
          <span>{countdownEnded ? "View Presale" : "Buy Now"}</span>
          <FaArrowRight aria-hidden="true" />
        </button>

        <small className="presale-announcement-modal__note">
          BSC · Secure wallet participation
        </small>
      </Modal.Body>
    </Modal>
  );
};

export default PresaleAnnouncementModal;
